import { render, staticRenderFns } from "./AccountVue.vue?vue&type=template&id=e23719b2&scoped=true&"
import script from "./AccountVue.vue?vue&type=script&lang=js&"
export * from "./AccountVue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e23719b2",
  null
  
)

export default component.exports